import LoginForm from "./LoginForm";
import Footer from "./Footer";
import Header from "./Header";

const LoginPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100">
      <div className="w-full max-w-md mx-4">
        <Header />
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl border border-gray-100/50 p-8 transition-all duration-300 hover:shadow-3xl">
          <div className="my-6 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
          <LoginForm />
          <div className="my-6 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;